/* Office Walker 2A — electricity calculator.
   motorised €/year = (powerW / 1000) * hours * 365 * tariff ;  Office Walker = €0. */
(function () {
  'use strict';
  function eur(n) { return '€' + Math.round(n).toLocaleString('en-US'); }
  document.querySelectorAll('[data-ow2-ecalc]').forEach(function (root) {
    var h = root.querySelector('[data-ec-hours]'), p = root.querySelector('[data-ec-power]'), t = root.querySelector('[data-ec-tariff]');
    var hv = root.querySelector('[data-ec-hours-val]'), pv = root.querySelector('[data-ec-power-val]'), tv = root.querySelector('[data-ec-tariff-val]');
    var motor = root.querySelector('[data-ec-motor]'), ten = root.querySelector('[data-ec-ten]');
    if (!h || !p || !t) return;
    function calc() {
      var H = Number(h.value), P = Number(p.value), T = Number(t.value);
      var yr = (P / 1000) * H * 365 * T;
      if (hv) hv.textContent = H;
      if (pv) pv.textContent = P;
      if (tv) tv.textContent = T.toFixed(2);
      if (motor) motor.textContent = eur(yr);
      if (ten) ten.textContent = eur(yr * 10);
    }
    h.addEventListener('input', calc); p.addEventListener('input', calc); t.addEventListener('input', calc);
    calc();
  });
})();
